
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trainer-form",
      function () {
        return require("private-next-pages/trainer-form.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trainer-form"])
      });
    }
  